import React from 'react';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import Router from 'routes';
import config from 'config';
import { useDeviceDetect } from 'hooks';
import store from 'store/store';
import queryClient from 'client/queryClient';
import wsClient from 'client/wsClient';
import WsContext from 'contexts/wsContext';
import i18n from './config/i18n';
import 'styles/index.css';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const { isDesktop } = useDeviceDetect();
  return (
    <WsContext.Provider value={wsClient}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <I18nextProvider i18n={i18n}>
            <Router />
          </I18nextProvider>
        </Provider>
        {config.isDevelopment && isDesktop && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </WsContext.Provider>
  );
}

export default App;
